<template>
  <!-- Snackbar for alert notifications -->
  <div>
    <v-snackbar
      v-for="(n, index) in notifications"
      :key="index"
      v-model="n.showing"
      bottom
      left
      :style="`bottom: ${(index) * 60}px`"
      v-bind="n.settings"
    >
      {{ n.message }}

      <template #action="{ attrs }">
        <v-btn
          v-if="n.hasButton"
          :color="n.buttonColor"
          text
          v-bind="attrs"
          icon
          @click="closeNotification(index)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { EventBus } from '../mixins'

export default {
  data: function () {
    return ({
      notifications: [],
      settings: {
        success: {
          hasButton: false,
          settings: {
            timeout: 3000,
            color: 'success'
          }
        },
        info: {
          hasButton: false,
          settings: {
            timeout: 3000,
            color: 'info'
          }
        },
        warning: {
          hasButton: false,
          settings: {
            timeout: 3000,
            color: 'warning',
            text: true,
            outlined: true
          }
        },
        danger: {
          showing: true,
          hasButton: true,
          buttonColor: 'white',
          settings: {
            color: 'error',
            timeout: -1
          }
        }
      }
    });
  },
  mounted () {
    // Listen for the show-notification event and its payload.
    EventBus.$on('show-notifications', this.addNotification);
  },
  methods: {
    addNotification (notifications) {
      const notificationsToShow = [];
      notifications.map(notification => {
        const noti = { ...this.settings[notification.type] };
        noti.showing = true;
        noti.message = notification.message;
        noti.settings.timeout = notification.timeout ? notification.timeout : noti.settings.timeout;
        notificationsToShow.push(noti);
      });
      this.notifications = notificationsToShow;
    },
    closeNotification (index) {
      this.notifications.splice(index, 1);
    }
  }
};

</script>